export default __webpack_public_path__ + "static/media/Scholar's Bracers of the Forbidden Art.80e91e4d.jpg";